import { PhoneNumberUtil } from 'google-libphonenumber';

const phoneUtil = PhoneNumberUtil.getInstance();

const isPhoneNumberPartiallyFilled = (phoneNumber: string) => {
  try {
    const parsedNumber = phoneUtil.parse(phoneNumber);
    if (parsedNumber.hasNationalNumber()) {
      return true;
    } else {
      return false;
    }
  } catch (e) {
    return false;
  }
};

export default isPhoneNumberPartiallyFilled;
